<template>
  <v-container fluid>
    <v-card flat color="background">
      <v-card-title>Delivery Hours</v-card-title>
      <v-card-subtitle>Currently: {{location.delivery_currently_available? 'DELIVERING': 'NOT DELIVERING'}}</v-card-subtitle>
      <v-card-text>
        <v-row align="center">
          <v-col cols="12" md="2">
            <p class="subtitle-1 d-inline">All Days</p>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon right color="grey" class="d-inline" v-on="on" size="20">help</v-icon>
              </template>
              <span>The times selected here will be reflected on all the days of the week</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12" md="2">
            <v-menu
              ref="openTime_allDays"
              :close-on-content-click="false"
              :return-value.sync="allDays.open_time"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field v-model="allDays.open_time" label="Open Time" readonly v-on="on"></v-text-field>
              </template>
              <v-time-picker v-model="allDays.open_time">
                <v-spacer></v-spacer>
                <v-btn
                  class="text-capitalize"
                  color="primary"
                  @click="$refs.openTime_allDays.save(allDays.open_time)"
                >Confirm</v-btn>
              </v-time-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" md="2">
            <v-menu
              ref="cutoffTime_allDays"
              :close-on-content-click="false"
              :return-value.sync="allDays.cutoff_time"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field v-model="allDays.cutoff_time" label="Close Time" readonly v-on="on"></v-text-field>
              </template>
              <v-time-picker v-model="allDays.cutoff_time">
                <v-spacer></v-spacer>
                <v-btn
                  class="text-capitalize"
                  color="primary"
                  @click="$refs.cutoffTime_allDays.save(allDays.cutoff_time)"
                >Confirm</v-btn>
              </v-time-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" md="2">
            <v-menu
              ref="closeTime_allDays"
              :close-on-content-click="false"
              :return-value.sync="allDays.close_time"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field v-model="allDays.close_time" label="Close Time" readonly v-on="on"></v-text-field>
              </template>
              <v-time-picker v-model="allDays.close_time">
                <v-spacer></v-spacer>
                <v-btn
                  class="text-capitalize"
                  color="primary"
                  @click="$refs.closeTime_allDays.save(allDays.close_time)"
                >Confirm</v-btn>
              </v-time-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" md="2">
            <v-switch inset :label="allDays.is_open?'Open':'Close'" v-model="allDays.is_open"></v-switch>
          </v-col>
          <v-col cols="12" md="2">
            <v-btn @click="applyAll" color="primary">Apply To All</v-btn>
          </v-col>
        </v-row>
        <v-data-table
          class="background"
          hide-default-footer
          :headers="headers"
          :items="location.delivery_hours"
        >
          <template v-slot:item.open_time="{ item }">
            <v-menu
              :ref="`openTime${item.day}`"
              :close-on-content-click="false"
              :return-value.sync="item.open_time"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field v-model="item.open_time" label="Open Time" readonly v-on="on"></v-text-field>
              </template>
              <v-time-picker v-model="item.open_time">
                <v-spacer></v-spacer>
                <v-btn class="text-capitalize" color="primary" @click="$refs[`openTime${item.day}`].save(item.open_time)">Confirm</v-btn>
              </v-time-picker>
            </v-menu>
          </template>
          <template v-slot:item.close_time="{ item }">
            <v-menu
              :ref="`closeTime_${item.day}`"
              :close-on-content-click="false"
              :return-value.sync="item.close_time"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field v-model="item.close_time" label="Close Time" readonly v-on="on"></v-text-field>
              </template>
              <v-time-picker v-model="item.close_time">
                <v-spacer></v-spacer>
                <v-btn
                  class="text-capitalize"
                  color="primary"
                  @click="$refs[`closeTime_${item.day}`].save(item.close_time)"
                >Confirm</v-btn>
              </v-time-picker>
            </v-menu>
          </template>
          <template v-slot:item.cutoff_time="{ item }">
            <v-menu
              :ref="`cutoffTime_${item.day}`"
              :close-on-content-click="false"
              :return-value.sync="item.cutoff_time"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field v-model="item.cutoff_time" label="Cut-off Time" readonly v-on="on"></v-text-field>
              </template>
              <v-time-picker v-model="item.cutoff_time">
                <v-spacer></v-spacer>
                <v-btn
                  class="text-capitalize"
                  color="primary"
                  @click="$refs[`cutoffTime_${item.day}`].save(item.cutoff_time)"
                >Confirm</v-btn>
              </v-time-picker>
            </v-menu>
          </template>
          <template v-slot:item.is_open="{ item }">
            <v-row class="justify-center">
              <v-switch inset label="Close/Open" v-model="item.is_open"></v-switch>
            </v-row>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="updateDeliveryHours">Save Changes</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { LocationAPI } from '@/clients/locations/locations.api'
export default {
  mounted() {
    this.getLocationDeliveryHours()
  },
  data() {
    return {
      allDays: {
        open_time: '00:00',
        close_time: '00:00',
        cutoff_time: '00:00',
        is_open: true
      },
      location: '',
      headers: [{
        text: 'Day',
        value: 'day_name'
      },
      {
        text: 'Open Time',
        value: 'open_time'
      },
      {
        text: 'Cut-Off Time',
        value: 'cutoff_time'
      },
      {
        text: 'Close Time',
        value: 'close_time'
      }, {
        text: 'Open',
        value: 'is_open',
        align: 'center'
      }]
    }
  },
  methods: {
    async getLocationDeliveryHours() {
      let response
      try {
        response = await LocationAPI.getLocationDeliveryHours(this.$route.params.id)
      } catch (error) {
        return console.log(error)
      }
      this.location = response.data.payload
    },
    applyAll() {
      this.location.delivery_hours.forEach((hour) => {
        hour.open_time = this.allDays.open_time
        hour.close_time = this.allDays.close_time
        hour.is_open = this.allDays.is_open
        hour.cutoff_time = this.allDays.cutoff_time
      })
    },
    async updateDeliveryHours() {
      this.location.delivery_hours.forEach(i => {
        if (i.open_time.length < 6) {
          i.open_time += ':00'
        }
        if (i.close_time.length < 6) {
          i.close_time += ':00'
        }
        if (i.cutoff_time.length < 6) {
          i.cutoff_time += ':00'
        }
      })
      try {
        await LocationAPI.updateLocationDeliveryHours(this.$route.params.id, { hours: this.location.delivery_hours })
      } catch (error) {
        return console.log(error)
      }
      this.swal({ type: 'success', title: 'Success', text: 'Delivery hours updated successfully.' })
      this.getLocationDeliveryHours()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
